// See 'Select Panel Historic' for old code that has been commented out.

// As part of the NPV Swap requirement - the ability to action the sendToPanel button can potentially happen from the legs table.
// Even if we keep the sending happening from the send to pannel table, the constand collapsing of the 'send to panel' table means the users settings are getting lost.
// Need to move the setting to a Zustand store and persist the setting on each widget as the user interacts with the UI.
// TODO: Check this method works with the pop out tiles.

import { chevronDown, chevronRight } from "@/components/icons/SVGIcons";
import {
  CubeCustomCellRenererProps,
  getFontSizeClass,
} from "@/components/widgets/tradeActionSummary/helper/actionSummaryHelper";
import useTableUIStore from "@/store/tableUIStore";
import { buildEditPanelMessage } from "./generateOutgoingTradeMessage";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import { StrategyType } from "@/lib/interfaces and Enums/ENUMStrategyType";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { NotationToDecimalValueType } from "@/lib/interfaces and Enums/TYPENotations";
import { IPanelSelection } from "@/store/savedPanelsStore";
import { defaultUserPanel } from "@/store/savedPanelsStoreACTIONS";
import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import { tradeContainsCloseLeg } from "../../helper/tradeSettingsHelper/unwindSideRule";
import { getBlocksData } from "@/store/tradeBlockDataStoreACTIONS";
import tradeDataStore from "@/store/tradeDataStore";
import { sendToPannelStoreAction } from "@/store/tradeDataStoreACTIONS";
import agGridFlashNotifications from "@/store/notifications/agGridFlashNotifications";
import tradeSettingsStore from "@/store/tradeSettingsStore";
import {
  addNewTradeSettingsAtNew,
  getEditSettingsAndAddToStore,
} from "@/store/tradeSettingsStoreACTIONS";
import { useAuth0 } from "@auth0/auth0-react";
import { useTheme } from "next-themes";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CPList from "./CPList";
import CPSettingsGrid from "./CPSettingsGrid";
import LegsTable from "./LegsTable";
import MainButtonActionSelectPanel from "./MainButtonActionSelectPanel";
import ReactSelectSavedPanel from "./ReactSelectSavedPanel";
import {
  findIcebergCellsUnderMinSize,
  validateNoNegativeOrderLevels,
  validateOrderLevelValues,
} from "./SelectPanelHelper";
import {
  buildIcebergMinSizeMessage,
  getIcebergBlocksForTrade,
} from "../../helper/cellRenderers/IcebergCellRenderer/icebergMinSizeHelpers";
import { generateToastMessageTradeData } from "@/lib/notifications/toastNotificationHelpers";
import SelectPanelUnwindIndicator from "./SelectPanelUnwindIndicator";
import SendAsSettings from "./SendAsSettings";


interface ISelectPanelIndex extends CubeCustomCellRenererProps {
  expandedRowsContext?: any;
  setExpandedRowsContext?: any;
  setExpandedRowsContextMostRecentlyUpdated: React.Dispatch<
    React.SetStateAction<string>
  >;
  isEditPanel: boolean;
  cryptoID?: string;
  isMiniTable?: boolean;
}

export interface selectPanelProps {
  data: any;
  expandedRowsContext: any;
  setExpandedRowsContext: any;
  setExpandedRowsContextMostRecentlyUpdated: React.Dispatch<
    React.SetStateAction<string>
  >;
  generateOutgoingTradeMessage: Function;
  // counterpartiesList: IToggleCounterpartiesButton[];
}

export function doesTradeAtNewContainSWPOrOption(
  data: ExecutionStrategy,
): boolean {
  if (data && data.legs && data.legs.length > 0) {
    return data.legs.some((leg) => {
      if (
        leg.instrumentType == InstrumentTypeCode.SWP ||
        leg.instrumentType == InstrumentTypeCode.OPT
      ) {
        return true;
      }
      return false;
    });
  }
  return false;
}

const SelectPanelIndex = ({
  data,
  expandedRowsContext,
  setExpandedRowsContext,
  setExpandedRowsContextMostRecentlyUpdated,
  isEditPanel,
  cryptoID,
  isMiniTable,
}: ISelectPanelIndex) => {
  const { getAccessTokenSilently } = useAuth0();
  // const [disable, setDisable] = useState(false); //disable actions to prevent errors in api call
  const tradeDataFromStore = tradeDataStore((state) => state.tradeData);
  const currentStoreTrade = tradeDataFromStore.find(
    (es) => es.esid == data.esid,
  );

  // Trade Settings - from store (derived directly to avoid extra re-render).
  const thisTradeSettings = tradeSettingsStore(
    (state) =>
      state.tradeSettingsData.find((t) => t.esid === data.esid)?.settings,
  );
  const { theme } = useTheme();
  const fontSizeSetting = useTableUIStore((state) => state.fontSize);
  const fontSizeClass = getFontSizeClass(fontSizeSetting);

  const [currentActiveTab, setCurrentActiveTab] =
    useState<IPanelSelection>(defaultUserPanel);
  const [showLegsTable, setShowLegsTable] = useState(true);

  // Trade tile full-height: measure the React Grid Layout widget container (.react-grid-item)
  // which has fixed pixel dimensions set by the layout, so it won't grow with AG Grid autoHeight.
  const containerRef = useRef<HTMLDivElement>(null);
  const [tileMinHeight, setTileMinHeight] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!isMiniTable || !containerRef.current) return;
    const widgetContainer = containerRef.current.closest(".react-grid-item");
    if (!widgetContainer) return;

    const measure = () => {
      const header = widgetContainer.querySelector(".ag-header");
      const headerHeight = header ? header.clientHeight : 0;
      // Subtract header + small buffer for row group panel / borders
      const available = widgetContainer.clientHeight - headerHeight - 200;
      if (available > 400) setTileMinHeight(available);
    };

    measure();
    const observer = new ResizeObserver(() => measure());
    observer.observe(widgetContainer);
    return () => observer.disconnect();
  }, [isMiniTable]);

  useEffect(() => {
    if (
      thisTradeSettings &&
      thisTradeSettings.tradeTypes.find((setting) => setting.active)?.name ==
        "Order"
    ) {
      if (currentStoreTrade?.strategyType == StrategyType.Structure) {
        if (thisTradeSettings && thisTradeSettings.orderSetLevelStructure) {
          const activeOrderSetLevelStructureName =
            thisTradeSettings.orderSetLevelStructure.find(
              (setting) => setting.active,
            )?.name;
          if (
            activeOrderSetLevelStructureName &&
            activeOrderSetLevelStructureName == "Spread / Legs" &&
            showLegsTable == false
          ) {
            setShowLegsTable(true);
          }
        }
      } else if (currentStoreTrade?.strategyType == StrategyType.Outright) {
        if (thisTradeSettings && thisTradeSettings.orderSetLevelOutright) {
          const activeOrderSetLevelOutrightName =
            thisTradeSettings.orderSetLevelOutright.find(
              (setting) => setting.active,
            )?.name;
          if (
            activeOrderSetLevelOutrightName &&
            activeOrderSetLevelOutrightName == "Leg" &&
            showLegsTable == false
          ) {
            setShowLegsTable(true);
          }
        }
      }
    }
  }, [thisTradeSettings]);
  // Function to add a trade to the settings store if it is not already in there.

  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    // When first loading the page, see if new settings need to be made for the current ESID.
    if (!thisTradeSettings) {
      addNewTradeSettingsAtNew({ esid: data.esid });
    }
    setHasLoaded(true);
  }, []);

  // LQC-774: Hydrate the settings store from the server whenever the Edit Panel
  // opens. Always refetch — stale local settings from a prior edit session are
  // more dangerous than overwriting unsaved in-flight edits (see note on
  // getEditSettingsAndAddToStore).
  useEffect(() => {
    if (!isEditPanel) return;
    getEditSettingsAndAddToStore({
      esid: data.esid,
      getAccessTokenSilently,
    });
  }, [isEditPanel, data.esid]);

  useEffect(() => {
    if (hasLoaded && thisTradeSettings) {
      async function attemptSend() {
        // Validate order level values before sending
        const validationResult = validateOrderLevelValues({
          esid: data.esid,
          currentStoreTrade,
        });

        if (!validationResult.isValid) {
          // Show toast message
          toast.error("Enter at least one level (Spread/Price or Leg)");

          // Trigger flash on cells
          tradeSettingsStore
            .getState()
            .updateOrderSettingFieldsToFlash(
              validationResult.settingFieldsToFlash,
            );
          tradeSettingsStore
            .getState()
            .updateLegCellsToFlash(validationResult.legCellsToFlash);

          setTimeout(() => {
            tradeSettingsStore.getState().clearOrderSettingFieldsToFlash();
            tradeSettingsStore.getState().clearLegCellsToFlash();
          }, agGridFlashNotifications.getState().validationFlashDuration);

          return; // Don't send the trade
        }

        // LQC-896: reject negative Set Level values on Orders for $p / $fr.
        // Mirrors the LQC-889 quote-side negative check — toast + flash + abort.
        const negativeLevelResult = validateNoNegativeOrderLevels({
          esid: data.esid,
          currentStoreTrade,
        });
        if (!negativeLevelResult.isValid) {
          generateToastMessageTradeData({
            action: "orderLevelNegative",
            result: "error",
            ESIDPassed: data.esid,
          });
          tradeSettingsStore
            .getState()
            .updateOrderSettingFieldsToFlash(
              negativeLevelResult.settingFieldsToFlash,
            );
          tradeSettingsStore
            .getState()
            .updateLegCellsToFlash(negativeLevelResult.legCellsToFlash);
          setTimeout(() => {
            tradeSettingsStore.getState().clearOrderSettingFieldsToFlash();
            tradeSettingsStore.getState().clearLegCellsToFlash();
          }, agGridFlashNotifications.getState().validationFlashDuration);
          return;
        }

        // LQC-2874: blocks may have changed in Trade Creation since the iceberg was set.
        const icebergCellsUnderMin = findIcebergCellsUnderMinSize(data.esid);
        if (icebergCellsUnderMin.length) {
          toast.error(
            buildIcebergMinSizeMessage(getIcebergBlocksForTrade(data.esid)),
          );
          tradeSettingsStore
            .getState()
            .updateIcebergCpCellsToFlash(icebergCellsUnderMin);
          setTimeout(
            () => tradeSettingsStore.getState().clearIcebergCpCellsToFlash(),
            agGridFlashNotifications.getState().validationFlashDuration,
          );
          return;
        }

        setHasLoaded(false);
        try {
          const wasSuccess = await sendToPannelStoreAction({
            outgoingTradeMessage: generateOutgoingTradeMessage(
              data.esid,
              data.notationES,
            ),
            getAccessTokenSilently: getAccessTokenSilently,
          });
          // Update state or perform other actions with the data
          if (!wasSuccess) {
            setHasLoaded(true);
          }
        } catch {
          setHasLoaded(true);
        }
      }
      // only attempt to send the trade if the CRYPTO id on the trade itself matches the ID of the widget.
      const idOnTrade = currentStoreTrade?.cryptoUpdated;
      if (cryptoID == idOnTrade) {
        attemptSend();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStoreTrade?.attemptSendTrade]);

  // const [counterpartiesList, setCounterpartiesList] = useState<
  //   IToggleCounterpartiesButton[]
  // >([]);

  function generateOutgoingTradeMessage(
    esid: string,
    notationES: NotationToDecimalValueType,
  ) {
    // LQC-1301 — message construction lives in a shared module so the blotter
    // Trade-Wide Settings popover sends the identical PUT /Trade/Execution/Edit
    // payload. `data` + `currentStoreTrade` are this panel's reactive values.
    return buildEditPanelMessage({
      esid,
      data,
      currentStoreTrade,
      notationES,
    });
  }

  const [showUnwindButton, setShowUnwindButton] = useState(false);
  const [containsClose, setContainsClose] = useState(false);

  const MainButtonActionSelectPanelProps = {
    data,
    expandedRowsContext,
    setExpandedRowsContext,
    setExpandedRowsContextMostRecentlyUpdated,
    generateOutgoingTradeMessage,
    // counterpartiesList,
  };

  const mainActionsProps = {
    // counterpartiesList,
    // setCounterpartiesList,
    // currentStoreTrade,
    currentActiveTab,
    setCurrentActiveTab,
    data,
    theme,
    cryptoID,
    isEditPanel,
  };

  // Update this to also call for the leg data if this trade has SWP
  useEffect(() => {
    data.legs?.forEach((leg: any) => {
      if (leg.instrumentType == "SWP") {
        setShowUnwindButton(true);
      }
    });
    // Shared with the Trade Settings sidebar so both lock Side the same way.
    if (tradeContainsCloseLeg(data)) {
      setContainsClose(true);
    }

    // Always fetch block data on mount since legs table starts open
    const blockData = tradeBlockDataStore.getState().tradeBlockData;
    const currentBlocks = blockData.find((block) => block.esid == data.esid);
    if (currentBlocks == undefined) {
      getBlocksData({
        esid: data.esid,
        getAccessTokenSilently: getAccessTokenSilently,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function legsToggleHandler(showLegsTable: boolean) {
    const blockData = tradeBlockDataStore.getState().tradeBlockData;
    const currentBlocks = blockData.find((block) => block.esid == data.esid);

    if (currentBlocks == undefined) {
      // Get the Leg data before loading the Leg table.
      getBlocksData({
        esid: data.esid,
        getAccessTokenSilently: getAccessTokenSilently,
      });
    }
    setShowLegsTable(!showLegsTable);
  }

  return (
    // CHECK WITH AKKIM: light mode has no background and uses a border - dark has no border and background colour.
    <div
      ref={containerRef}
      className="mb-1 flex min-h-[300px] w-full flex-row rounded-b-xl border-b-2 border-l-2 border-r-2 border-[#EDEDED] p-1 pr-2 dark:border-none"
      style={tileMinHeight ? { minHeight: tileMinHeight } : undefined}
    >
      <div className="flex w-full flex-col">
        <div className="flex w-full flex-col pl-2.5">
          {!isEditPanel && <SendAsSettings data={data} />}
          <div className="flex w-full flex-col items-start gap-2 pt-2">
            {isEditPanel && (
              <MainButtonActionSelectPanel
                {...MainButtonActionSelectPanelProps}
              />
            )}
            <ReactSelectSavedPanel {...mainActionsProps} />
          </div>

          <div className="w-full">
            <CPList {...mainActionsProps} />
          </div>
        </div>
        {/* Settings + Bank Overrides + Order settings */}
        {(data.status == ExecutionStrategyStatus.New || isEditPanel) && (
          <CPSettingsGrid
            esid={data.esid}
            data={data}
            containsClose={containsClose}
            isEditPanel={isEditPanel}
          />
        )}
        <div className="mt-2 w-full">
          <div className="flex pl-3">
            <button
              data-testid="toggleLegsTableBtn"
              onClick={() => legsToggleHandler(showLegsTable)}
              className={`flex cursor-pointer items-center gap-1 pb-2 ${fontSizeClass} text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200`}
            >
              {showLegsTable ? chevronDown : chevronRight}
              {showLegsTable ? (
                <span className="uppercase tracking-wider">Hide Legs</span>
              ) : (
                <>
                  <span className="uppercase tracking-wider">Show Legs</span>
                  {showUnwindButton && (
                    <span id={"SelectPanelUnwind"}>/ Unwind Swaps</span>
                  )}
                  {showUnwindButton && (
                    <SelectPanelUnwindIndicator esid={data.esid} />
                  )}
                </>
              )}
            </button>
          </div>

          <div
            className={`overflow-hidden pl-2 transition-all duration-150 ${showLegsTable ? "max-h-[200px] opacity-100" : "max-h-0 opacity-0"}`}
          >
            <LegsTable
              data={data}
              getAccessTokenSilently={getAccessTokenSilently}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectPanelIndex;
